import { render, staticRenderFns } from "./CardContactPerson.vue?vue&type=template&id=0a7db11b&"
import script from "./CardContactPerson.vue?vue&type=script&lang=js&"
export * from "./CardContactPerson.vue?vue&type=script&lang=js&"
import style0 from "./CardContactPerson.vue?vue&type=style&index=0&id=0a7db11b&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports